// components/DraggingNodePreview.tsx
import React from "react";
import { Box, Typography } from "@mui/material";

interface DraggingNodePreviewProps {
  x: number;
  y: number;
  width: number;
  height: number;
  color: string;
  userName: string;
  shape: "rectangle" | "circle" | "diamond" | "ellipse";
}

const DraggingNodePreview: React.FC<DraggingNodePreviewProps> = ({
  x,
  y,
  width,
  height,
  color,
  userName,
  shape,
}) => {
  const getShapeStyles = () => {
    const baseStyles = {
      position: "absolute" as const,
      left: x,
      top: y,
      width,
      height,
      border: `3px dashed ${color}`,
      backgroundColor: `${color}20`, // 20% opacity
      pointerEvents: "none" as const,
      zIndex: 999,
      transition: "all 0.1s ease-out",
    };

    switch (shape) {
      case "circle":
        return { ...baseStyles, borderRadius: "50%" };
      case "diamond":
        return { ...baseStyles, borderRadius: 0, transform: "rotate(45deg)" };
      case "ellipse":
        return { ...baseStyles, borderRadius: "50%" };
      default:
        return { ...baseStyles, borderRadius: 2 };
    }
  };

  return (
    <>
      <Box sx={getShapeStyles()} />
      <Typography
        variant="caption"
        sx={{
          position: "absolute",
          left: x + width + 10,
          top: y,
          backgroundColor: color,
          color: "white",
          px: 1,
          py: 0.5,
          borderRadius: 1,
          fontSize: "0.75rem",
          whiteSpace: "nowrap",
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          pointerEvents: "none",
          zIndex: 1000,
        }}
      >
        {userName} is dragging
      </Typography>
    </>
  );
};

export default DraggingNodePreview;
